"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Button.default;
  }
});
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
if (process.env.NODE_ENV !== "production") {
  console.error('⚠️ Deprecation component "Button". Use direct import @material-ui/core/Button instead');
}
/**
 * @deprecated use direct import &#64;material-ui/core/Button instead
 */